export const SUPPORTED_LANGUAGES = ['en', 'ar', 'ru'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'en';
export const RTL_LANGUAGES: Language[] = ['ar'];

export const isRtlLanguage = (lang: Language): boolean => RTL_LANGUAGES.includes(lang);
